import { createContext, ReactNode, useContext, useState } from 'react'

interface FilterContextType {
  filter: string
  setFilter: (filter: string) => void
  clearFilter: () => void
}

const FilterContext = createContext<FilterContextType | undefined>(undefined)

export function FilterProvider({ children }: { children: ReactNode }) {
  const [filter, setFilter] = useState('')

  const clearFilter = () => setFilter('')

  return (
    <FilterContext.Provider
      value={{
        filter,
        setFilter,
        clearFilter,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

export function useFilter() {
  const context = useContext(FilterContext)
  if (context === undefined) {
    throw new Error('useFilter must be used within a FilterProvider')
  }
  return context
}
